import PropTypes from 'prop-types';
// hooks
import useAuth from '../hooks/useAuth';
// components
import P403 from '../components/P403';
// import LoadingScreen from '../components/LoadingScreen';
// pages
import { ROLE_NAMES } from '../config';
// import Login from '../pages/auth/Login';

// ----------------------------------------------------------------------

function checkPermission(accessibleRoles = [], userRoleName = '') {
  return accessibleRoles.includes(ROLE_NAMES.all) || accessibleRoles.includes(userRoleName);
}

// ----------------------------------------------------------------------

RoleBasedGuard.propTypes = {
  accessibleRoles: PropTypes.arrayOf(
    PropTypes.oneOf([ROLE_NAMES.root, ROLE_NAMES.admin, ROLE_NAMES.manager, ROLE_NAMES.staff, ROLE_NAMES.all])
  ),
  children: PropTypes.node,
};

// It's required to be placed inside AuthGuard
export default function RoleBasedGuard({ accessibleRoles = [], children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();

  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  const hasRequiredRoles = checkPermission(accessibleRoles, user?.roleName);

  if (!hasRequiredRoles) {
    return <P403 />;
  }

  return <>{children}</>;
}
